import { IOrdCompra } from '../models/IOrdCompra.model';
import { ROUTE_LOGISTICA } from './../constants/constant.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class OrdCompraService {


    constructor(
        private apiService: ApiService,
        private http: HttpClient
    ) { }

    insertarOrdCompra(data: IOrdCompra): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudOrdCompra);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarOrdCompra(data: IOrdCompra): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudOrdCompra);
        return this.apiService.executePutJson(data).pipe();
    }

    calcularOrdCompra(data: IOrdCompra): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.calcularOrdCompra);
        return this.apiService.executePutJson(data).pipe();
    }

    buscarOrdCompra(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number,destin:number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.buscarOrdCompra);
        return this.apiService.execGetQueryJson(`?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&destin=${destin}&limit=${limit}&offset=${offset}`).pipe();
    }

    download_pdf(_formato: number, numint: number, cia: string) {
        let fullUrl: any = null;
        if (_formato == 1)
            fullUrl = environment.serviceUrl_Report + `orden-compra/${numint}/report/public/format-1.pdf?` + "cia=" + cia;
        if (_formato == 2)
            fullUrl = environment.serviceUrl_Report + `orden-compra/${numint}/report/public/format-2.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(fullUrl, httpOptions);
    }

    reutilizarOrdCompra(serie : number, numdoc : number){
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudOrdCompra);
        return this.apiService.execGetQueryJson(`/${serie}/${numdoc}`).pipe();
    }

      /******************MODAL DOC PADRE*******************/
      
    listCotizacionPendientes(femisi: string, moneda: string,codsuc: number, codpro: string): Observable<any> {
        this.apiService.setUrlPathApi('requerimiento-compra/buscar/pendientes-aprobados');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codpro=${codpro}`).pipe();
    }

    listRequerImpPendientes(femisi: string, moneda: string,codsuc: number, codpro: string): Observable<any> {
        this.apiService.setUrlPathApi('importacion-req-compra/buscar/pendientes-aprobados');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codpro=${codpro}`).pipe();
    }

    getDetallePendiente(numints: string): Observable<any> {
        this.apiService.setUrlPathApi('documento-generico/detalle-pendiente');
        return this.apiService.execGetQueryJson(`?numints=${numints}`).pipe();
    }

    visar(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `orden-compra/${numint}/visar?` + "coduser=" + coduser, { observe: 'response' });
    }

    aprobar(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `orden-compra/${numint}/aprobar?` + "coduser=" + coduser, { observe: 'response' });
    }

    rechazar(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `orden-compra/${numint}/rechazar?` + "coduser=" + coduser, { observe: 'response' });
    }

    anular(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `orden-compra/${numint}/anular?` + "coduser=" + coduser, {}, { observe: 'response' });
    }

    obtenerOrdCompra(numint : number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudOrdCompra);
        return this.apiService.execGetQueryJson(`/${numint}`).pipe();
    }

    obtenerOrdCompraImp(numint : number): Observable<any> {
        this.apiService.setUrlPathApi('importacion-orden-compra');
        return this.apiService.execGetQueryJson(`/${numint}`).pipe();
    }

    downloadExcelComercialResportesOrdenCompra(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi('consultas/orden-compra');
        return this.apiService.execGetQueryJsonPDF(`/excel.xlsx?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
      }

    actualizarArancel(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudOrdCompra+'/modificar-arancel');
        return this.apiService.executePutJson(data).pipe();
    }  
}
